<template>
  <div class="pushMonitorIndex">
    <div class="flex-row flex-nowrap flex-block justify-content-end m-b-xs page-operate-block">
      <el-button v-if="isShowBtn('add')"  class="primary-btn-g m-r-xs" size="small" icon="Plus" name="dataSetting" @click="handleEdit('add')">新增</el-button>
      <el-button v-if="isShowBtn('update')"  class="primary-btn-g m-r-xs" size="small" icon="Edit" name="dataSetting" :disabled="options.selection.length!=1" @click="handleEdit('edit')">编辑</el-button>
      <el-button v-if="isShowBtn('delete')"  class="danger-btn-g" size="small" icon="Delete" :disabled="options.selection.length<1" @click="handlePatchDelete(true,'get')">删除</el-button>
    </div>
    <r-table
      :ref="tableVarity"
      :columns="tableColumn"
      :dataSource="tableData"
      :options="options"
      :pagination="pagination"
      @current-change="handlePageChange"
      @row-click="handleRowClick"
    ></r-table>

    <!--查看-->
    <!--<RModal title="详情" v-model="detailModal" :closeOnClick="false" @change="detailModal = false"  @close="closeModel">-->
    <Modal :modalTitle="modalTitle" modalId="detailModalId" class="smallModalDialog" @close="detailModal = false" :width="'60%'">
        <edit-view v-if="detailType=='add' || detailType=='edit'" :detailType="detailType" :detailModal="detailModal" :detailData="detailData" :selOptions="selOptions" :selOptionMaps="selOptionMaps" @submitSuccess="submitSuccess" @closeModel="closeModel">
        </edit-view>
    </Modal>
    <!--</RModal>-->
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import RModal from '@/components/common/RModal'
  import RTable from '@/components/common/RTable'
  import tableMix from '@/components/common/tableListMixin.js'
  import checkMix from '@/components/common/checkAll.js'
  import editView from './editView'
export default {
  name: 'pushIndex',
  mixins: [tableMix, checkMix],
  components: { RTable ,RModal,editView},
  data() {
    let detailKeys = []
    let searchData = {}
    detailKeys.map((key)=>{
      searchData[key] = ''
    })
    return {
      perms: [],

      modalTitle:'详情',
      detailModal:false,
      detailType:'show',
      uploadModal:false,
      downloadUrl:'',
      detailData:{},
      deleteUrl:'SAAS.DATAPUSH_ALARM_DELETE',
      areUOk: false,
      tableVarity: 'baseinfo_employee',
      tableColumn: [],
      tableData: [],
      selOptions:{monitor_type:[]},
      selOptionMaps:{monitor_type:{}},
      options: {
        multiSelect: true, // 多选
        serialNum: false, // 显示序号
        loading: false, // 加载中状态
        initTable: true, // 是否一挂载就加载数据
        height: 'calc(100vh - 295px)',
        mutiSelect: true,
        selection: [],
      },
      pagination: {
        total: 0,
        pageIndex: 1,
        pageSize: 20,
      },
      // 查询参数
      filters: { search: searchData },
    }
  },

  watch: {
    detailModal(val) {
      if(this.detailType=='add'){
        this.modalTitle = '新增'
      }else if(this.detailType=='edit'){
        this.modalTitle = '编辑'
      }else if(this.detailType=='push'){
        this.modalTitle = '手动推送'
      }else{
        this.modalTitle = '详情'
      }


      if(val){
        $('#detailModalId').modal({ backdrop: 'static', show: true })
      }else{
        $('#detailModalId').modal('hide')
      }
    },
  },
  created() {
    this.perms = 'perms' in localStorage && localStorage.perms !== '' ? JSON.parse(localStorage.perms) : []
    this.initTableColumns()
    this.getDictData()
    this.getDataList()
  },
  mounted() {

  },
  methods: {
    ...mapActions(['importUpload']),
    // 是否显示这个按钮
    isShowBtn(perm) {
      let url = window.location.pathname.substr(5)
      let len = this.perms.length
      let pid = ''
      for (let i = 0; i < len; i++) {
        if (this.perms[i].url == url) {
          pid = this.perms[i].id
        }
      }
      for (let i = 0; i < len; i++) {
        if (this.perms[i].pid == pid && this.perms[i].perm == perm) {
          return true
        }
      }

      return false
    },
    // 获取字典数据
    getDictData() {
      let url = 'RESOURCE.GET_MULTI_LIST'
      this.fetchData({
        url,
        method: 'get',
        params: {
          type: 'monitor_type',
          start: 0,
          size: 1000,
          toExcel: false
        }
      }).then( res => {
        this.selOptions.monitor_type = res.data
        let maps = {}
        res.data.map((obj)=>{
          maps[obj.name] = obj.value
        })
        this.selOptionMaps.monitor_type = maps
      })

    },
    // 查询列表数据
    getQuery() {
      this.options.loading = true
      let params = this.getQueryParams2()

      let url = 'SAAS.DATAPUSH_ALARM_LIST'
      this.fetchData({
        url,
        method: 'post',
        params,
      })
        .then((res) => {
          this.options.loading = false
          if (this.toExcel == true) {
            if (!res || !res.data) {
              this.$message.error('操作失败！')
            } else {
              window.location.href = res.data
            }
            this.toExcel = false
            return
          }

          if (!res || !res.data) {
            this.tableData = []
            this.pagination.total = 0
          } else {
            this.tableData = res.data || []
            this.pagination.total = res.count
          }
        })
        .catch((err) => {
          console.log(err, 'errorInfo')
        })
        .finally(() => {
          this.options.loading = false
          this.toExcel = false
        })
    },
    // 初始化自定义表头
    initTableColumns() {
      let columns = [
        { prop: 'typeName', label: '监控类型', visible: true, minWidth: 160, isInput: true },
        { prop: 'expTimingInterval', label: '定时接口调用间隔', visible: true, minWidth: 160, isSelect: false  },
        { prop: 'expPushInterval', label: '异常告警间隔', visible: true, minWidth: 160, isInput: false },
        { prop: 'phone', label: '异常告警手机', visible: true, minWidth: 160, isInput: false },
        { prop: 'email', label: '异常告警邮箱', visible: true, minWidth: 160, isSelect: false },
        { prop: 'detectTime', label: '最近告警时间', visible: true, minWidth: 160, isSelect: false },
        { prop: 'monitorTime', label: '最近监控时间', visible: true, minWidth: 160, isSelect: false },
        { prop: 'detectResult', label: '最近监控结果', visible: true, minWidth: 160, isSelect: false },
        { prop: 'resultDesc', label: '监控结果说明', visible: true, minWidth: 160, isSelect: false },
      ]

      columns.forEach((item) => {
        if(item.prop=='detectResult'){
          item.render =  (row, index, column)=>{
            let detectResultMaps = {1:'成功',2:'失败',0:'session失效',9:'未登录'}
            return <span>{detectResultMaps[row.detectResult]} </span>;
          }
        }
      })

      this.tableColumn = columns
    },
    handleEdit(detailType){
      this.$nextTick(()=>{
        this.detailType = detailType
        this.detailModal = true
        if(detailType=='edit' && this.options.selection.length){
          this.detailData = {...this.options.selection[0]}
        }else{
          this.detailData = {}
        }

      })
    },
    submitSuccess(){
      this.detailModal=false
      this.detailType = ''
      this.getDataList()
    },
    closeModel(){
      this.detailModal=false
    },
    handlePush(){
      this.$nextTick(()=>{
        this.detailType = 'push'
        this.detailModal = true
      })
    },
  }
}
</script>

<style lang="less" scoped>
  .pushMonitorIndex{
    border: 1px solid #fff;  //操作按钮栏布局异常，这里加上border后正常
  }
.log-title {
  font-size: 22px;
  font-weight: 600;
}
</style>
